// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2A_qD","right":"styles_right__2Wszs"};